export type Optional<T> = T | null | undefined;

export interface PaginatedResponse<Item> {
	page: number;
	totalPages: number;
	totalItems: number;
	items: Item[];
}

export enum SortDirection {
	ASC = 'ASC',
	DESC = 'DESC'
}

export enum Params {
	page = 'page',
	pageSize = 'pageSize',
	sortBy = 'sortBy',
	sortDirection = 'sortDirection',
	search = 'search',
	mgId = 'mgId',
	type = 'type',
	status = 'status',
	tab = 'tab',
	reportForm = 'reportForm',
	editedReportId = 'editedReportId',
	staff = 'staff',
	deploymentType = 'deploymentType',
	swapReason = 'swapReason',
	hasExternalAntennas = 'hasExternalAntennas'
}
